import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AirLineIcon,
  AirportIcon,
  ArrowDown,
  Close,
  CountryIcon,
  DashboardIcon, DocumentIcon, EmailIcon, ExitIcon,
  InformationIcon,
  JobPositionIcon,
  LocationIcon,
  Logo,
  MailIcon,
  MensIcon, MenuIcon, MessageIcon,
  PaymentIcon,
  ProductIcon,
  ProvinceIcon,
  ReportIcon, RoleIcon, SettingIcon,
  Ship2Icon,
  UsersIcon,
  Visa2Icon,
  VisaIcon,
  WharfIcon
} from "../../icons/icons";
import { useTranslation } from "react-i18next";
import useDirection from "../../hooks/useDirection";
import { toggleAuth } from "../../store/user/user.reducer";
import { setPermissions } from "../../store/permissions/permissions.reducer";
import { createFileURL } from 'src/utils/new'

const baseInfoMenuItems = [
  {
    icon: CountryIcon,
    link: "/basic-information/country",
    tKey: "country",
  },

  {
    icon: ProvinceIcon,
    link: "/basic-information/state",
    tKey: "state",
  },

  {
    icon: LocationIcon,
    link: "/basic-information/city",
    tKey: "city",
  },


  {
    icon: Ship2Icon,
    link: "/basic-information/ship",
    tKey: "ship",
  },

  {
    icon: Ship2Icon,
    link: "/basic-information/ship-type",
    tKey: "shipType",
  },

  {
    icon: WharfIcon,
    link: "/basic-information/wharf",
    tKey: "wharf",
  },


  {
    icon: AirportIcon,
    link: "/basic-information/airport",
    tKey: "airport",
  },
  {
    icon: AirLineIcon,
    link: "/basic-information/airline",
    tKey: "airline",
  },

  {
    icon: Visa2Icon,
    link: "/basic-information/visa",
    tKey: "visa",
  },

  {
    icon: JobPositionIcon,
    link: "/basic-information/job-levels",
    tKey: "jobLevels",
  },

  {
    icon: JobPositionIcon,
    link: "/basic-information/jobs",
    tKey: "job",
  },


  {
    icon: RoleIcon,
    link: "/basic-information/role",
    tKey: "role",
  },

  {
    icon: UsersIcon,
    link: "/basic-information/users",
    tKey: "users",
  },

  {
    icon: EmailIcon,
    link: "/basic-information/emails",
    tKey: "emails",
  },

  {
    icon: EmailIcon,
    link: "/basic-information/document",
    tKey: "documentsManagement",
  },



]


const SideBar = () => {
  const [toggle, setToggle] = useState(false)
  const { t } = useTranslation();
  const directionClass = useDirection();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(toggleAuth([]))
    dispatch(setPermissions([]))
    navigate("/auth/login");
  }

  const { pathname } = useLocation()
  const lng = useSelector((state) => state.common.lng)
  const user = useSelector((state) => state.user.user)
  const permissions = useSelector((state) => state.permissions?.permissions)
  const isAdmin = user?.role_key === "super_admin"
  const isAgent = user?.role_key === "agent"
  const isCrewAgent = user?.role_key?.toLowerCase() == "CrewAgent"?.toLowerCase()



  const SideBarSubItem = ({ link, tKey, icon: Icon }) => {
    return <li className={` text-sm mx-5 pr-1 cursor-pointer flex flex-row gap-2 items-center ${pathname == link ? 'text-gray-800 font-bold' : 'text-gray-300'}`}>
      <Icon className='size-5' />
      <Link to={link} className="flex-1 text-left rtl:text-right whitespace-nowrap">{t(tKey)} </Link>
    </li>
  }


  return (
    <div>
      <span onClick={() => setToggle(!toggle)} className={`md:hidden absolute ${directionClass ? "right-2" : "left-2"} top-4`}>
        <MenuIcon />
      </span>
      <div onClick={(e) => e.target === e.currentTarget && setToggle(false)} className={`bg-modal w-screen h-screen md:w-0 fixed top-0 z-40 transition-transform ${!toggle && directionClass && " translate-x-full "} ${!toggle && !directionClass && " -translate-x-full "} sm:translate-x-0 `}>
        <aside id="sidebar-multi-level-sidebar"
          className={` ${lng === "en" ? "left-0" : "right-0"} w-[270px] h-screen transition-transform`}
          aria-label="Sidebar">
          <div className={"flex flex-col justify-between h-full overflow-y-auto bg-white border-l-2 border-gray-300"}>
            <div className=" pt-5 px-5 ">
              <div className={'flex justify-right items-center'}>
                <Link to={"/dashboard"}>
                  <Logo />
                </Link>
              </div>

              <div className={"border border-gray-400 rounded-lg py-2 px-4 my-6 flex items-center"}>
                {!!user?.picture
                  ? <img src={createFileURL(user?.picture)} className={"w-[45px] h-[45px] bg-gray-300 rounded-full object-cover"} />
                  : <div className={"w-[45px] h-[45px] bg-gray-300 rounded-full"} />}
                <div className={"flex flex-col mx-2"}>
                  <span className={"text-sm mb-1"}>{(user?.name || "") + ' ' + (user?.last_name || "")}</span>
                  <span className={"text-[11px] text-gray-500"}>{user?.role_key || "crew"}</span>
                </div>
              </div>
              <div className={"text-xs text-gray-600 mt-1 mb-5"}>{t("mainMenu")}</div>
              <ul className="space-y-4 font-medium">
                {!isCrewAgent && <li>
                  <Link to={"/dashboard"}
                    className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                    <DashboardIcon />
                    <span className="text-[15px] text-gray-500">{t("dashboard")}</span>
                  </Link>

                </li>}
                {
                  (permissions?.role_permissions?.BasicInformation?.[0]?.access || permissions?.full_access === 1)  &&
                  <li>
                    <button type="button"
                      className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                      aria-controls="dropdown-example" data-collapse-toggle="dropdown-example">
                      <InformationIcon color={"#8A9098"} />
                      <Link className="flex-1 text-left rtl:text-right whitespace-nowrap text-gray-500 text-[15px]">{t("basicInformation")}</Link>
                      <ArrowDown />
                    </button>
                    <ul id="dropdown-example" className="hidden py-2 space-y-5">

                      {baseInfoMenuItems.map((item, index) => <SideBarSubItem
                        key={item}
                        {...item}
                      />)}

                      {/* <SideBarSubItem
                        icon={LocationIcon}
                        link={"/basic-information/country"}
                        tKey={"country"}
                      />

                      <SideBarSubItem
                        icon={LocationIcon}
                        link={"/basic-information/state"}
                        tKey={"state"}
                      />


                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/city"} className=" flex-1 text-left rtl:text-right whitespace-nowrap">{t("city")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/ship"} className=" flex-1 text-left rtl:text-right whitespace-nowrap"> {t("ship")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/wharf"} className=" flex-1 text-left rtl:text-right whitespace-nowrap"> {t("wharf")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/airport"} className=" flex-1 text-left rtl:text-right whitespace-nowrap"> {t("airport")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/airline"} className=" flex-1 text-left rtl:text-right whitespace-nowrap"> {t("airline")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/visa"} className=" flex-1 text-left rtl:text-right whitespace-nowrap">{t("visa")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/jobs"} className=" flex-1 text-left rtl:text-right whitespace-nowrap">{t("job")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/role"} className=" flex-1 text-left rtl:text-right whitespace-nowrap">{t("role")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/users"} className=" flex-1 text-left rtl:text-right whitespace-nowrap">{t("user")}</Link>
                      </li>
                      <li className={"text-gray-300 text-sm mx-5 cursor-pointer"}>
                        <Link to={"/basic-information/emails"} className=" flex-1 text-left rtl:text-right whitespace-nowrap">{t("emails")}</Link>
                      </li> */}
                    </ul>
                  </li>
                }
                {
                  (permissions?.role_permissions?.User?.[0]?.access || permissions?.full_access === 1) &&

                  <li>
                    <Link to={"/crew"}
                      className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                      <MensIcon />
                      <span className="text-[15px] text-gray-500">{t("crew")}</span>
                    </Link>
                  </li>
                }

                {
                  (permissions?.role_permissions?.Visa?.[0]?.access || permissions?.full_access === 1) &&
                  <li>
                    <Link to={"/visa-orders"}
                      className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                      <VisaIcon />
                      <span className="text-[15px] text-gray-500">{t("visaOrders")}</span>
                    </Link>
                  </li>
                }
                {
                  (permissions?.role_permissions?.Visa?.[0]?.access || permissions?.full_access === 1) && isAdmin &&
                  <li>
                    <Link to={"/canceled-visas"}
                      className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                      <VisaIcon color='gray' />
                      <span className="text-[15px] text-gray-500">{t("CanceledVisas")}</span>
                    </Link>
                  </li>
                }
                {
                  (permissions?.role_permissions?.Finance?.[0]?.access || permissions?.full_access === 1) &&
                  <li>
                    <Link to={"/transactions"}
                      className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                      <PaymentIcon />
                      <span className="text-[15px] text-gray-500">{t("transactions")}</span>
                    </Link>
                  </li>
                }

                {
                  (permissions?.role_permissions?.Finance?.[0]?.access || permissions?.full_access === 1) &&
                  <li>
                    <Link to={"/active-visas"}
                      className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                      <VisaIcon color='gray' />
                      <span className="text-[15px] text-gray-500">{t("activeVisas")}</span>
                    </Link>
                  </li>
                }

                {isAgent && <li>
                  <button type="button"
                    className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                    aria-controls="dropdown-example-2" data-collapse-toggle="dropdown-example-2">
                    <DocumentIcon color={"#8A9098"} className='size-6 mx-2' />
                    <Link className="flex-1 text-left rtl:text-right whitespace-nowrap text-gray-500 text-[15px]">{t("reports")}</Link>
                    <ArrowDown />
                  </button>
                  <ul id="dropdown-example-2" className="hidden py-2 space-y-5">

                    <SideBarSubItem
                      icon={Visa2Icon}
                      link={'/reports/unpaid'}
                      tKey={'unpaid'}
                    />

                  </ul>

                </li>}
                {
                  (permissions?.role_permissions?.Permission?.[0]?.access || permissions?.full_access === 1) &&
                  <li>
                    <Link to={"/setting"}
                      className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                      <SettingIcon />
                      <span className="text-[15px] text-gray-500">{t("setting")}</span>
                    </Link>
                  </li>
                }

              </ul>
            </div>
            <div className={"border border-gray-400 rounded-lg py-4 px-2  flex flex-col items-start gap-1  justify-start cursor-pointer mx-5 mt-16"}>
              <span className={"text-primary-600 text-sm"}>
                {t("ourCompanyText")}
              </span>
              <span className={"text-gray-500 text-xs mt-4"}>
                {t("fromDate")}
              </span>
              <span className={"text-gray-500 text-xs mb-3"}>
                {t("toDate")}
              </span>
              <div className={"border-1 border-primary-400 text-primary-400 p-2 bg-primary-200 rounded-xl w-full text-sm flex justify-between"}>
                {t("insideTel")}
                <span>
                  021-88644190
                </span>
              </div>
            </div>
            <div className={"border border-gray-400 rounded-lg py-2 px-4 my-6 flex items-center   justify-center cursor-pointer mx-5"}>
              <button className={"flex items-center"} onClick={handleLogout}>
                <ExitIcon />
                <span className={"text-[13px] text-gray-500"}>{t("exit")}</span>
              </button>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default SideBar;
